$(document).ready(function(){
  const searchTrigger = document.querySelector('.search-trigger');
  const searchBox = document.querySelector('.search__box');
  const searchClose = document.querySelector('.search-close');

  searchTrigger.addEventListener('click', function(e) {
    e.preventDefault();
    searchBox.style.display = 'flex';
    // Force reflow
    searchBox.offsetHeight;
    searchBox.classList.add('active');
    searchBox.querySelector('input').focus();
  });

  searchClose.addEventListener('click', function() {
    searchBox.classList.remove('active');
    searchBox.addEventListener('transitionend', function handler() {
      searchBox.style.display = 'none';
      searchBox.removeEventListener('transitionend', handler);
    });
  });

	$('.account__tab--switcher ul li a').on('click' ,function(e){
		e.preventDefault();
		if (!$(this).hasClass("current")) {
			$(this).closest("ul").find(".current").removeClass('current');
			$(this).addClass('current');
			$('.context__box').css('display' , "none");
			console.log($('.context__box.' + $(this).attr("data-class")));
			$('.context__box.' + $(this).attr("data-class")).fadeIn(300);
		}
	});



	$('.step__three .back-btn').on('click',function(e){
		e.preventDefault();
		$('.size__picker').css("display" ,"none");
		$('.uploaded__files , .upload__photos').fadeIn(300);
		$('.form__wrapper .steps>.elem__step:nth-child(3)').removeClass('current');
		$('.step__three').css('display' ,"none");
		$('.step__one').fadeIn(300);
	});

	$('.step__four .back-btn').on('click',function(e){
		e.preventDefault();
		$('.option__wrapper').css("display" ,"none");
		$('.size__picker').fadeIn(300);
		$('.form__wrapper .steps>.elem__step:nth-child(5)').removeClass('current');
		$('.step__four').css('display' ,"none");
		$('.step__three').fadeIn(300);
	});


	$('.added__cart .outline-btn').on("click" ,function(e){
		e.preventDefault();
		$('.added__cart').fadeOut(300);
		$('.form__modal').fadeOut(300);
        showExtras();
		$('body,html').css("overflow-y" ,"initial");
		$('.header-container').css("top" , "0px");
		$('.header-container').css("position" , "sticky");
	});

	$('.cancel-btn').on("click"  ,function(e){
		e.preventDefault();
		$('.form__modal').fadeOut(300);
        showExtras();
		$('body,html').css("overflow-y" ,"initial");
		$('.header-container').css("top" , "0px");
		$('.header-container').css("position" , "sticky");
        if($('form#account_form').length){
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
        $('form#account_form').show();
	});

	$('.choose__box>a').on('click'  ,function(e){
		e.preventDefault();
		$(this).closest('.choose__box').find(".current").removeClass("current");
		$(this).addClass('current');
	});

	$('.dropdown>a').on('click' ,function(e){
		e.preventDefault();
		if ($(this).hasClass("opened")) {
			$(this).removeClass("opened");
			$(this).closest('.dropdown').find(".dropdown__box").fadeOut(300);
		} else {
			$('.dropdown>a').removeClass('opened');
			$('.dropdown .dropdown__box').fadeOut(300);
			$(this).addClass('opened');
			$(this).closest('.dropdown').find(".dropdown__box").fadeIn(300);
		}
	});

	$('.dropdown__box ul li a').on("click" ,function(e){
		e.preventDefault();
		let newP = $(this).find("p").clone();
		$(this).closest(".dropdown").find(">a>p").replaceWith(newP);
		$('.dropdown>a').removeClass('opened');
		$('.dropdown .dropdown__box').fadeOut(300);
	});

	$(document).click(function(event) { 
	  var $target = $(event.target);
	  if(!$target.closest('.dropdown').length) {
	  	$('.dropdown>a').removeClass('opened');
	  	$('.dropdown .dropdown__box').fadeOut(300);
	  }        
	});

	$('.more>a').on('click' ,function(e){
		e.preventDefault();
		if ($(this).hasClass("opened")) {
			$(this).removeClass("opened");
			$(this).closest('.desc').find('.controls').removeClass("active");
		} else {
			$('.more>a').removeClass('opened');
			$('.desc .controls').removeClass('active');
			$(this).addClass("opened");
			$(this).closest('.desc').find('.controls').addClass("active");
		}
	});


	$(document).click(function(event) { 
	  var $target = $(event.target);
	  if(!$target.closest('.more').length  && !$target.closest('.controls').length ) {
	  	$('.more>a').removeClass('opened');
	  	$('.controls').removeClass('active');
	  }        
	});

	// if ($('.circle').length) {
	// 	$('.circle').each(function(index,elem){
	// 		$(elem).circleProgress({
	// 		    value: 0.5,
	// 		    size: 50,
	// 		    animation:false,
	// 		    fill: "#EE4B2B"
	// 		  });
	// 	});
	// }


	$(document).on('click', '.size__picker--list .elem',function(e){
		$(this).find("input").prop("checked" ,  true);
	});

	$(document).on('click', '.grid__photos .elem .media' ,function(e){
		if ($(this).find(".inn__loading").length == 0) {
			$(this).closest('.grid__photos').find(".elem .selected").removeClass("selected");
			$(this).addClass("selected");
            $('.floating-buttons').removeClass('hidden')
			$('.form__wrapper .bottom__part  .step__one .regular-btn').removeClass('disabled');
		}
	});

	$('.info__button').on("mouseenter" ,function(){
		$('.tooltip__box[data-tool='+ $(this).attr("data-tool") +']').fadeIn(150);
		$('.tooltip__box[data-tool='+ $(this).attr("data-tool") +']').css("top" ,$(this).offset().top - $('.tooltip__box[data-tool='+ $(this).attr("data-tool") +']').outerHeight() - 5);
		$('.tooltip__box[data-tool='+ $(this).attr("data-tool") +']').css("left" ,$(this).offset().left - $('.tooltip__box[data-tool='+ $(this).attr("data-tool") +']').outerWidth()/2);
		if ($(this).closest('.choose__element').length) {
			$('.tooltip__box[data-tool='+ $(this).attr("data-tool") +']').addClass('no__space');
		}
	});
	$('.info__button').on("mouseleave" ,function(){
		$('.tooltip__box').fadeOut(150);
	});


	$('.droppable__area').on('click' ,function(e){
		e.preventDefault();
		$(this).closest('.upload__photos').find('input[type="file"]').click();
	});
	// $('.bottom__part .step__one .regular-btn').on('click' ,function(e){
	// 	e.preventDefault();
	// 	$('.step__one').css("display" ,'none');
	// 	$('.step__three').fadeIn(300);
	// 	$('.upload__photos').css('display' , "none");
	// 	$('.size__picker').fadeIn(300);
	// 	$('.photos__info').css("display" , "none");
	// 	$('.steps .elem__step:nth-child(3)').addClass('current');
	// 	if ($(window).width() < 700) {
	// 		$('.step__three .regular-btn').removeClass("disabled");
	// 	}
	// });


	

	$('.upload__photos input[type="file"]').on('change' ,function(){
		// $('.step__one').css("display" ,"none");
		// $('.step__two').fadeIn(300);
		// $('.bottom__part').addClass("second__state");
		// $('.uploaded__files').fadeIn(300);
		$('.grid__photos .elem').fadeIn(300);
		calculateHeight();
	});
	$('body').on('drop', '.droppable__area', function(e) {
		$('.step__one').css("display" ,"none");
		$('.step__two').fadeIn(300);
		$('.bottom__part').addClass("second__state");
		$('.uploaded__files').fadeIn(300);
		e.preventDefault();
	});

	$('.step__two .regular-btn').on('click'  ,function(e){
		e.preventDefault();
		$('.step__two').css("display" ,"none");
		$('.step__three').fadeIn(300);
		$('.upload__photos').css('display' , "none");
		$('.uploaded__files').css('display' , "none");
		$('.size__picker').fadeIn(300);
		$('.steps .elem__step:nth-child(3)').addClass('current');
		calculateHeight();
	});
	// $('.step__three .regular-btn').on('click'  ,function(e){
	// 	e.preventDefault();
	// 	$('.step__three').css("display" ,"none");
	// 	$('.step__four').fadeIn(300);
	// 	$('.size__picker').css('display' , "none");
	// 	$('.option__wrapper').fadeIn(300);
	// 	$('.steps .elem__step:nth-child(5)').addClass('current');
	// 	calculateHeight();
	// });


	// $('.step__four .regular-btn').on('click' ,function(e){
	// 	e.preventDefault();
	// 	$('.added__cart').fadeIn(300);
	// });
	// $('.added__cart .regular-btn').on("click" ,function(e){
	// 	e.preventDefault();
        
	// });

	$(window).on(
	    'dragover',
	    function(e) {
	        e.preventDefault();
	        e.stopPropagation();
	        $('.droppable__area .overlay').css('opacity' ,"1");
	    }
	)
	$(window).on(
	    'dragenter',
	    function(e) {
	        e.preventDefault();
	        e.stopPropagation();
	        $('.droppable__area .overlay').css('opacity' ,"1");
	    }
	)
	let dragLeaveTimer;
	$(window).on(
	    'dragleave',
	    function(e) {
	        e.preventDefault();
	        e.stopPropagation();
	        if (dragLeaveTimer){
	        	clearTimeout(dragLeaveTimer);
	        	dragLeaveTimer = setTimeout(function(){
	        		$('.droppable__area .overlay').css('opacity' ,"0");
	        	}, 300);
	        } else {
	        	dragLeaveTimer = setTimeout(function(){
	        		$('.droppable__area .overlay').css('opacity' ,"0");
	        	}, 300);
	        }
	    }
	)

	if ($('.form__modal').length) {
		let topSpace = 0;
		let floatTop = $('header').outerHeight();
		let topPartSpace = 0;
		if ($(window).scrollTop() < floatTop) {
			topPartSpace = floatTop - $(window).scrollTop();
		}
		$('.form__modal').css("top"  , topPartSpace + "px");	
		$('.form__modal').css("height", $(window).height() - topPartSpace);
		calculateHeight();
	}
	function calculateHeight(){
		$('.outer__form .top__part').css("height" , $('.outer__form').outerHeight() - $('.outer__form .bottom__part').outerHeight() -  $("header").outerHeight()  + "px");
	}
	$(window).on('resize' , function(){
		if ($('.form__modal').length) {
			let topSpace = 0;
			let floatTop = $('header').outerHeight();
			let topPartSpace = 0;
			// if ($(window).scrollTop() < floatTop) {
			// 	topPartSpace = floatTop - $(window).scrollTop();
			// }
			$('.form__modal').css("height", $(window).height() - topPartSpace);
			$('.form__modal').css("top"  , topPartSpace + $('header').outerHeight() + "px");	
			calculateHeight();
		}

	});


	$('.open__popup').on('click' ,function(e){
		e.preventDefault();
        hideExtras();
        window.scrollTo(0,1)

		$('body,html').css("overflow-y" ,"hidden");
		$('.form__modal').fadeIn(300);
		let topSpace = 0;
		let floatTop = $('header').outerHeight();
		let topPartSpace = 0;
		// if ($(window).scrollTop() < floatTop) {
		// 	topPartSpace = floatTop - $(window).scrollTop();
		// } 
		$('.form__modal').css("height", $(window).height() - topPartSpace);
		$('.form__modal').css("top"  , floatTop + "px");	
		calculateHeight();
		$('.outer__form .top__part').css("height" , $('.outer__form').outerHeight() - $('.outer__form .bottom__part').outerHeight() -  $("header").outerHeight() + "px");
        $('form#account_form').hide();
	});

	// $('.order__id').on('click' ,function(e){
	// 	e.preventDefault();
	// 	$('.orders__list').css("display" ,"none");
	// 	$('.order__inner').fadeIn(300);
	// });

	$('.order__inner .title>.back>a').on('click' ,function(e){
		e.preventDefault();
		$('.order__inner').css('display' , "none");
		$('.orders__list').fadeIn(300);
	});

	$('.add__new--address').on('click' ,function(e){
		e.preventDefault();
        clearAddressForm();
		$('.context__box.addresses>.address__list , .context__box.addresses>.new__button').css("display" ,"none");
		$('.context__box.addresses .add__new--address--box').fadeIn(300);
	});

    function clearAddressForm() {
        document.getElementById('address_first_name_new').value = '';
        document.getElementById('address_last_name_new').value = '';
        document.getElementById('address_zip_new').value = '';
        document.getElementById('address_address1_new').value = '';
        document.getElementById('address_address2_new').value = '';
        document.getElementById('address_city_new').value = '';
        document.getElementById('address_province_new').value = '';
        document.getElementById('address_country_new').value = ''; // If there's a country field
        document.getElementById('address_phone_new').value = ''; // If there's a phone field

        const form = document.getElementById('address_form_new'); // Use the specific ID of your form
        form.action = `/account/addresses/`;
  }

      function update_address_table(){
        fetch('/account')
        .then(response => response.text())
        .then(html => {
          // Create a temporary DOM element to parse the fetched HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
      
          // Select the div with id "address_table_box" within the fetched HTML
          const addressTableBox = tempDiv.querySelector('#address_table_box');
      
          // Append or manipulate the fetched content as needed
          if (addressTableBox) {
            document.getElementById('address_table_box').innerHTML = addressTableBox.innerHTML;
          }
        })
        .catch(error => {
          console.error('Error fetching content:', error);
        });
        
      }

     $(document).on('click', '.address-deletee', function(evt) {
        evt.preventDefault();
        var $el = $(this);
        var target = $el.data('target');
        var confirmMessage = $el.data('confirm-message');
        if (
          confirm(confirmMessage || 'Are you sure you wish to delete this address?')
        ) {
               fetch(target, {
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({ _method: 'delete' })
                })
              .then(response => {
                    // Handle successful response, e.g., remove the address element from the DOM or show a success message
                    console.log('Address deleted successfully');
                    update_address_table();
              })
            .catch(error => {
              console.error('Error:', error);
            });
        }
      });
  
$('.add__new--address--box .submit a').on("click" ,function(e){
		e.preventDefault();
		$('.add__new--address--box').css('display' ,"none");
		$('.context__box.addresses>.address__list , .context__box.addresses .new__button').fadeIn(300);
	});
  
	$('.add__new--address--box .submit button').on("click" ,function(e){
		e.preventDefault();
        let form_act = $('.add__new--address--box .submit button , .add__new--address--box form').prop('action').split('/')
        
        $.ajax({
          type: form_act[form_act.length-1].includes('addresses')?'POST':'PUT',
          url: $('.add__new--address--box .submit button , .add__new--address--box form').prop('action'),
          data: $('.add__new--address--box .submit button , .add__new--address--box form').serialize(), // Serialize the form data
          success: function(response) {
            // Handle success (e.g., show a success message or redirect)
            console.log('Address saved successfully!');
            update_address_table();
          },
          error: function(xhr, status, error) {
            // Handle errors (e.g., show an error message)
            update_address_table();
          }
        });
		$('.add__new--address--box').css('display' ,"none");
		$('.context__box.addresses>.address__list , .context__box.addresses .new__button').fadeIn(300);
	});

	$('header .shop>a').on('click' ,function(e){
		e.preventDefault();
		$('.overlay__cart').fadeIn(300);
		$('body,html').css("overflow-y" ,"hidden");
		setTimeout(function(){
            hideExtras()
			$('.cart__side').addClass('opened');
		},150);
	});

	$('.overlay__cart , .cart__side .continue__shopping>a').on("click" ,function(e){
		e.preventDefault();
		$('.cart__side').removeClass('opened');
        showExtras()
		setTimeout(function(){
			$('.overlay__cart').fadeOut(300);
            $('body,html').css("overflow-y" ,"initial");
		}, 150);
	});

   if ($('.small__squares').length) {
        const $smallSlider = $('.small__squares .inn__slider');

        $smallSlider.slick({
            vertical: true,
            dots: false,
            verticalSwiping: true,
            infinite: false,
            swipe: true,
            asNavFor: '.gallery__big--slider',
            swipeToSlide: false,
            accessibility: false,
            arrows: false,
            focusOnChange: false,
            focusOnSelect: false
        }).css('display', 'block');

        // Sync small squares with the big gallery slider
        // $smallSlider.on('afterChange', function (event, slick, currentSlide) {
        //     const targetIndex = $('.small__squares .slick-current .slide').data("index");
        //     $('.gallery__big--slider').slick('slickGoTo', targetIndex);
        // });

        // Click event to navigate big slider based on small slider click
        $('body').on("click", ".small__squares .slide > a", function (e) {
            e.preventDefault();
            const targetIndex = $(this).closest('.slide').data("index");
            $('.gallery__big--slider').slick('slickGoTo', targetIndex);
        });
    }

    // Initialize Big Gallery Slider
    if ($('.gallery__big--slider').length) {
        const $bigSlider = $('.gallery__big--slider');

        $bigSlider.slick({
            slidesToShow: 1,
            arrows: false,
            infinite: false,
            asNavFor: '.small__squares .inn__slider'
        });

        // Manual navigation for big slider using custom buttons
        $('.gallery__top--hero .prev__btn').on('click', function (e) {
            e.preventDefault();
            $bigSlider.slick('slickPrev');
        });

        $('.gallery__top--hero .next__btn').on('click', function (e) {
            e.preventDefault();
            $bigSlider.slick('slickNext');
        });

        // Sync big gallery slider with the small squares slider
        $bigSlider.on('afterChange', function (event, slick, currentSlide) {
            const targetIndex = $('.gallery__big--slider .slick-current .slide').data("index");
            if(parseInt(targetIndex) == 0){
              $('.create__print .outer__create>.gallery__slider .gallery__top--hero .prev__btn').css('opacity', '0')
            }else{
              $('.create__print .outer__create>.gallery__slider .gallery__top--hero .prev__btn').css('opacity', '1')
            }

          if(parseInt(targetIndex) == $('.create__print .outer__create>.gallery__slider .gallery__top--hero .gallery__big--slider .slick-slide').length-1){
            $('.create__print .outer__create>.gallery__slider .gallery__top--hero .next__btn').css('opacity', '0')
          }else{
            $('.create__print .outer__create>.gallery__slider .gallery__top--hero .next__btn').css('opacity', '1')
          }
          
            //$(".small__squares .inn__slider").slick('slickGoTo', targetIndex);
            // $(".gallery__big--slider .slick-current .slide").addClass('selected').siblings().removeClass('selected');
        });
    }


	$('.accordions>.elem>.head').on("click" ,function(){
		if ($(this).closest('.elem').hasClass("opened")) {
			$(this).closest('.elem').removeClass("opened");
			$(this).closest('.elem').find('.content').slideUp(300);
		} else {
			$(this).closest('.elem').addClass('opened');
			$(this).closest('.elem').find('.content').slideDown(300);
		}
	});

	$('.mobile__info>.menu>a').on('click' ,function(e){
		e.preventDefault();
		$('.menu__mobile').css('left' ,'0px');
		$('.overlay').fadeIn(300);
	});


	$('.overlay').on('click' ,function(e){
		e.preventDefault();
		$(this).fadeOut(300);
		$('.menu__mobile').css("left" ,'-340px');
	});

	$('.menu__mobile .main__step .title>a').on("click" ,function(e){
		e.preventDefault();
		$('.overlay').fadeOut(300);
		$('.menu__mobile').css("left" ,'-340px');
	});

	$('.menu__mobile .main__step>ul li a.sub__menu').on("click" ,function(e){
		e.preventDefault();
		$(this).closest('.main__step').addClass("closed");
		$('.secondary__step[data-id='+ $(this).attr("data-id") +']').addClass('current');
	});

	$('.menu__mobile .secondary__step>ul li a.inner__menu').on("click" ,function(e){
		e.preventDefault();
		$(this).closest('.secondary__step').addClass("closed");
		$('.secondary__step[data-id='+ $(this).attr("data-id") +']').addClass('current');
	});

	$('.secondary__step .back__btn>a').on('click' ,function(e){
		e.preventDefault();
		if ($(this).closest('.secondary__step').attr("data-parent") != undefined) {
			$(this).closest('.secondary__step').removeClass('current');
			$('.secondary__step[data-id='+ $(this).closest(".secondary__step").attr('data-parent') +']').removeClass('closed');
		} else {
			$(this).closest('.secondary__step').removeClass('current');
			$('.main__step').removeClass('closed');
		}
	});

	$("header .search>a").on('click' ,function(e){
		e.preventDefault();
		$('.search__box').fadeIn(300);
		$('header .float').addClass('active');
	});
	$('header .float').on("click" ,function(e){
		e.preventDefault();
		$('.search__box').fadeOut(300);
		$('header .float').removeClass('active');
	});

	if ($('.hero__slider').length) {
		$('.outer__hero').slick({
			slidesToShow:1,
			arrows:true,
			autoplay:true,
			speed:1500,
			autoplaySpeed:4000,
			responsive: [
		    {
		      breakpoint: 767,
		      settings: {
		        arrows:false,
		        dots:true
		      }
		    }
		  ]
		});
		$('.outer__hero').css("display" , "block");
		$('.hero__slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$('.hero__slider .animated').removeClass("animated");
			$('.hero__slider .slick-current .desc>h1').addClass("animated");
			setTimeout(() =>{
				$('.hero__slider .slick-current .desc>p').addClass("animated");
			}, 40);
			setTimeout(() =>{
				$('.hero__slider .slick-current .desc>.btn').addClass("animated");
			}, 80);
		});
		$('.hero__slider .btn__back').on("click" ,function(e){
			e.preventDefault();
			$('.hero__slider .slick-prev').click();
		});
		$('.hero__slider .btn__next').on("click" ,function(e){
			e.preventDefault();
			$('.hero__slider .slick-next').click();
		});
	}



});

  var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$%%amount-".replaceAll('%', '{').replace('-', '}}');
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



    // Fetch and render cart data
    function fetchCart() {
        $.getJSON('/cart.js', function(cart) {
            renderCart(cart);
        });
    }

    // Render the cart with updated data
    function renderCart(cart) {
        let cartHtml = '';
        $('.title p sup').text(cart.item_count);
        $('.subtotal .top__sub p').text(Shopify.formatMoney(cart.total_price));

        $.each(cart.items, function(index, item) {
            // Set up default image and check for _Thumbnail property
            let imageSrc = item.image || item.featured_image.url;
            let idProperty = null;
            let media_type_present = false;
            let media_type_text = '';

            // Loop through item properties to find specific keys (e.g., _Thumbnail and ID)
            $.each(item.properties, function(propertyName, propertyValue) {
                if (propertyName.includes('_Thumbnail') && propertyValue) {
                    imageSrc = propertyValue;
                }
                if (propertyName === 'ID') {
                    idProperty = propertyValue;
                }

                if(propertyName.includes('Media Type')){
                  media_type_text = propertyValue;
                  media_type_present = true;
                }
            });

            // Build HTML for each cart item, including dynamic properties
            cartHtml += `
                <div class="row" data-line="${index + 1}">
                    <div class="main">
                        <div class="media">
                            <img src="${imageSrc}" alt="${item.title}" loading="lazy" width="60" height="auto">
                        </div>
                        <div class="desc">
                            <p>${item.product_title}</p>
                            <div class="info">
                                <span class="big">${item.variant_title}${media_type_present?' / '+media_type_text:''}</span>
                                <a href="${item.url}" class="edit_options" onclick="event.preventDefault();edit_options('${ media_type_present }','${ item.key }','${ item.variant_options[0] }','${ item.handle }')">Edit</a>
                                <a class="remove_item-cart" data-line="${index + 1}" href="#">Remove</a>
                            </div>`;
            
            // Add the ID property if it exists
            if (idProperty) {
                cartHtml += `<span class="small">ID: ${idProperty}</span>`;
            }

            cartHtml += `
                        </div>
                    </div>
                    <div class="other">
                        <div class="price">
                            <p>${Shopify.formatMoney(item.price)}</p>
                        </div>
                        <div class="quantity">
                            <a href="#" class="quantity-decrease">
                                <img src="https://cdn.shopify.com/s/files/1/0754/3878/4819/files/minus.svg" alt="minus" loading="lazy" width="16" height="16">
                            </a>
                            <input type="text" value="${item.quantity}" readonly>
                            <a href="#" class="quantity-increase">
                                <img src="https://cdn.shopify.com/s/files/1/0754/3878/4819/files/plus.svg" alt="plus" loading="lazy" width="16" height="16">
                            </a>
                        </div>
                        <div class="title">
                            <p>${Shopify.formatMoney(item.line_price)}</p>
                        </div>
                    </div>
                </div>
            `;
        });

        $('.products .list').html(cartHtml);
    }


    
    $(document).on('click', '.empty-cart-btn', function(event) {
        event.preventDefault();
        var question = confirm('Are you sure, you want to clear the cart?');
        if(question) {
          $.ajax({
              type: 'GET',
              url: '/cart/clear',
              success: function(cart) {
                  fetchCart(); // Refresh cart display
              }
          });
        }
    });

    // Increase item quantity
    $(document).on('click', '.quantity-increase', function(event) {
        event.preventDefault();
        const line = $(this).closest('.row').data('line');
        $(this).closest('.row').addClass('loading')
        const currentQuantity = parseInt($(this).siblings('input').val());
        $(this).find('img').prop('src', 'https://cdn.shopify.com/s/files/1/0754/3878/4819/files/Rolling_1x-1.0s-200px-200px.svg?v=1730194656')
        updateCartItem(line, currentQuantity + 1);
    });

    // Decrease item quantity
    $(document).on('click', '.quantity-decrease', function(event) {
        event.preventDefault();
        
        const line = $(this).closest('.row').data('line');
        const currentQuantity = parseInt($(this).siblings('input').val());
        if (currentQuantity > 0) {
            $(this).closest('.row').addClass('loading')
            $(this).find('img').prop('src', 'https://cdn.shopify.com/s/files/1/0754/3878/4819/files/Rolling_1x-1.0s-200px-200px.svg?v=1730194656')
            updateCartItem(line, currentQuantity - 1);
        }
    });

   $(document).on('click', 'a.remove_item-cart', function(event) {
      event.preventDefault();
      let line = $(this).data('line');
      updateCartItem(line, 0);
    });

    // Update cart item quantity
    function updateCartItem(line, quantity) {
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { line: line, quantity: quantity },
            dataType: 'json',
            success: function(cart) {
                fetchCart(); // Refresh cart display
            }
        });
    }

function hideExtras(){
  $('div#smile-ui-container, iframe#launcher').parent().addClass('remove-extra');
}

function showExtras(){
  $('div#smile-ui-container, iframe#launcher').parent().removeClass('remove-extra');
}

